import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Card,
  Grid,
  CardHeader,
  CardContent,
  Divider,
} from '@material-ui/core';
import { format } from 'date-fns';

import { useRootStore } from '../../../stores/BridgeProvider';
import Spinner from '../../util/Spinner';
import { CustomTable } from '../../common/CustomTable';
import { filterCaseInsensitive } from '../../util/TableUtils';
import { NumberHandler } from '../../util/NumberHandler';

const dealColumnsConfig = [
  {
    Header: 'Title',
    accessor: 'Title',
    id: 1,
  },
  {
    Header: 'Number',
    Cell: ({ row: { original } }) => (
      <div style={{ textAlign: 'center' }}>{original.DealNumber}</div>
    ),
    id: 2,
    width: 60,
  },
  {
    Header: 'Transaction Date',
    Cell: ({ row: { original } }) => (
      <div style={{ textAlign: 'center' }}>
        {original.TransactionDate
          ? format(original.TransactionDate, 'MM/DD/YYYY')
          : 'N/A'}
      </div>
    ),
    id: 3,
    width: 80,
  },
  {
    Header: 'AR Amount',
    accessor: d => d.ARAmount,
    Cell: ({ row }) =>
      row.original.ARAmount ? (
        <NumberHandler
          num={row.original.ARAmount}
          currency="$"
          justify="flex-end"
          float={2}
        />
      ) : (
        'N/A'
      ),
    id: 4,
    width: 60,
  },
];

const TopOpenDeals = () => {
  const history = useHistory();
  const [isLoading, setLoading] = useState(true);
  const { dataStore } = useRootStore();
  const deals = dataStore.topOpenDealsArray;

  useEffect(() => {
    const initialActions = async () => {
      await dataStore.retrieveTopOpenDeals();
      setLoading(false);
    };
    initialActions();
  }, []);

  if (isLoading) return <Spinner />;

  return (
    <Grid item lg={12} xs={12}>
      <Card style={{ height: '100%' }}>
        <CardHeader title="Top Open Deals" />
        <Divider />
        <CardContent style={{ padding: 0 }}>
          <CustomTable
            data={deals}
            columns={dealColumnsConfig}
            defaultPageSize={5}
            trClassName="react-table-hover-row"
            resizable={false}
            filterable={false}
            showPageSizeOptions={false}
            noDataText="No vouchers"
            defaultFilterMethod={filterCaseInsensitive}
            disableQueryParams
            fixedHeight
            hideHeader
            showPagination={false}
            getTrProps={({ row }) => ({
              onClick: () => history.push(`/deal/${row.original.DealId}`),
            })}
          />
        </CardContent>
      </Card>
    </Grid>
  );
};

export default TopOpenDeals;
